import type {
  GetSettings200AimManualFlowsItem,
  PatchSettingsBodyAimManualFlowsItem,
} from '@ipfabric/api-client/client/schemas';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import { AimFlowsTable } from '../components/ApplicationMapping/tables/AimFlowsTable';
import type { DiscoverySettingsObject } from '../model/DiscoverySettingsObject';
import type { AimFlowDraft } from '../model/aimDrafts';

type AimFlowsFieldValues = {
  aimFlows: AimFlowDraft[];
};

export const storedAimFlows: FormSnippet<
  DiscoverySettingsObject,
  AimFlowsFieldValues
> = {
  render: ({ form }) => <AimFlowsTable form={form as never} />,

  fromModel: (model, draft) => {
    draft.aimFlows = (model.aim?.manual?.flows ?? []).map((f) => ({
      id: f.id,
      srcWorkloadId: f.srcWorkloadId,
      dstWorkloadId: f.dstWorkloadId,
      srcIp: f.srcIp,
      dstIp: f.dstIp,
      srcPort: f.srcPort,
      dstPort: f.dstPort,
      protocol: f.protocol,
    }));
  },

  toModel: (values, modelDraft) => {
    modelDraft.aim ??= {
      integrations: [],
      manual: { applications: [], workloads: [], flows: [] },
    };
    modelDraft.aim.manual ??= { applications: [], workloads: [], flows: [] };
    // PATCH DTO omits server-generated timestamps; cast to satisfy the model
    // field type (GetSettings200AimManualFlowsItem[]) which the immer draft uses.
    modelDraft.aim.manual.flows = values.aimFlows.map(
      (f): PatchSettingsBodyAimManualFlowsItem => ({
        id: f.id,
        srcWorkloadId: f.srcWorkloadId,
        dstWorkloadId: f.dstWorkloadId,
        srcIp: f.srcIp,
        dstIp: f.dstIp,
        srcPort: f.srcPort,
        dstPort: f.dstPort,
        protocol: f.protocol,
      }),
    ) as GetSettings200AimManualFlowsItem[];
  },

  schema: z.object({
    aimFlows: z.array(z.unknown()),
  }) as z.Schema<AimFlowsFieldValues>,
};
